<template>
  <div class="info">
    <div class="info-content">
      <div class="left">
        <div class="l-t">
          <div class="title">中国石油化工股份有限公司安庆分公司中石化安庆分公司炼油转化工结构调整项目自动喷水灭火系统招标公告[变更公告]</div>
          <p class="time">2022-01-24</p>
        </div>
        <div class="left-c">
          <div class="text1">本标在中国石化电子招标投标平台操作，请登录电子招标投标平台并使用CA数字证书加密制作投标文件，操作流程见下方说明。</div>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;发布日期：<strong>2022年1月23日</strong></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;中国石化国际事业有限公司受<strong>中国石油化工股份有限公司安庆分公司委托</strong>，对<strong>安庆石化炼油转化工结构调整项目自动喷水灭火系统公开招标</strong>所需<strong>自动喷水灭火系统</strong>进行公开招标。今发布公告，请符合条件的投标人报名参加。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;1.招标编号：<strong>WZ20220215-3603-857-B1</strong></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;2.项目内容：<strong>安庆石化炼油转化工结构调整项目自动喷水灭火系统公开招标</strong></p>
          <p>项目概况：项目已通过审批，资金已落实。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;3.招标物资名称、数量：</p>
          <table style="margin: auto" border="1">
            <tr>
              <th class="w-1">序号</th>
              <th class="w-2">物资</th>
              <th class="w-1">数量</th>
              <th class="w-1">计量单位</th>
              <th class="w-1">备注</th>
            </tr>
            <tr>
              <td class="w-1">1</td>
              <td class="w-2">自动喷水灭火系统\立体仓库 12300m3 1600点 20#+镀锌 洒水喷头ZSTZ 铜合金</td>
              <td class="w-1">1.00</td>
              <td class="w-1">套</td>
              <td class="w-1">包1-自动喷水灭火系统</td>
            </tr>
          </table>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;4.交货期和地点：<strong>2022年5月31日、中石化安庆石化公司物资采购中心仓库 安徽省安庆市大观区蔡山路48号</strong></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;5.投标人的基本资格要求：</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;5.1投标人具有营业执照、税务登记证、组织机构代码证，或按照“三证合一”登记制度登记，执照有效。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;5.2投标截止日投标人未被工商行政管理机关在国家企业信用信息公示系统列入严重违法失信企业名单；且未被 “信用中国”网站列入失信被执行人名单。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;5.3投标人未处于被中国石化给予风险停用、违约停用处理期内。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;5.4投标人不存在被责令停产停业、暂扣或者吊销许可证、暂扣或者吊销执照；不存在进入清算程序，或者被宣告破产，或者其他丧失履约能力的情形。须提供由法定代表人或授权代表签署并加盖公章的承诺书。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;5.5投标人近两年内没有发生重大安全责任事故。须提供由法定代表人或授权代表签署并加盖公章的承诺书。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;6.其他资格要求（详细要求具体见招标文件）：1.投标人须具有近三年(2019年至今）石油化工行业自动喷水灭火系统\立体仓库 3000m3 以上且稳定运行1年及以上的使用业绩，提供业绩合同、发票复印件、用户证明等相关证明文件。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;7.本次招标接受生产商（制造商）申请，不接受代理商投标、不接受流通商投标。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;8．本次招标不接受联合体投标。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;9．评标方法：综合评标法</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;10．招标文件费用：招标文件费用1000.00元人民币，采用网上支付的方式购买，招标文件售后不退。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;11．招标文件售卖时间：2022年1月22日 8:00至2022年1月29日 17:00（北京时间，下同）。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;12．招标文件售卖方式：招标文件采取网上在线购买方式，申请人在中国石化物资电子招标投标交易平台(http://bidding.sinopec.com)注册，填报基本信息（基本信息包括营业执照、税务登记证、组织机构代码证等），经基本信息审核通过后获得用户名和密码并登录平台（在中国石化物资电子招投标交易平台http://bidding.sinopec.com或中国石化物资采购电子商务平台http://ec.sinopec.com有用户名和密码的，直接登录即可），网上支付招标文件费用后，下载招标文件。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;13．投标文件递交地点：电子投标文件、纸质版投标文件按要求分别单独密封后递交至江苏省南京市秦淮区龙蟠中路216号金城大厦A区6层中国石化国际事业有限公司南京招标中心招标大厅（其中电子投标文件必须使用中国石化物资电子招标投标交易平台提供的投标文件制作工具编制，使用U盘存放；纸质版投标文件为电子投标文件的书面打印版本，并在首页加盖公司公章）。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;14．投标截止时间：2022年02月10日 09:00。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;15．开标时间：2022年02月10日 09:00。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;开标地点：江苏省南京市秦淮区龙蟠中路216号金城大厦A区6层中国石化国际事业有限公司南京招标中心招标大厅。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;16．发布公告的媒介：本公告在中国采购与招标网、中国石化物资电子招标投标交易平台(http://bidding.sinopec.com)、中国石化物资采购电子商务平台（http://zgsh.sinopec.com）同时发布，本公告的修改、补充在以上媒介同时发布。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;17．凡对本次招标提出询问，请在2022年02月10日 09:00前与徐旭联系，技术咨询请与郭方联系（技术方面的询问请以信函或传真的形式）。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;18．其他重要要求：1、投标方应承诺满足绿色采购要求：设备自行设计或制造应遵循标准化、系列化、通用化的原则，充分考虑设备的适用性、可靠性、维修性、安全环保、经济和运行周期，禁止选用国家明令淘汰的设备；供应商无论是外协采购还是自行制造，首先应提供通过环境标志产品认证、节能产品认证或者国家认可的节能环保物资；在合同执行过程中，甲方有权对发生安全环保事故的供应商，视情节轻重，及时采取降低采购份额、暂停采购或者终止采购合同等措施；产品包装材料应使用可回收、循环再利用材料，最大限度减少包装废弃物。未承诺，评标委员会有权否决；2、投标方在购买标书后依据标书确定是否参加投标，如不参加投标，要求在购买标书后5日内向招标中心提交加盖公章的放弃投标函，未履行的供应商纳入投标不诚信记录，在新一轮招标评标中予以扣分。3、投标方应承诺，中标后在1个月内申请法人信用认证和产品质量评价，3个月内完成评价。未履行承诺的供应商纳入投标不诚信记录，在新一轮招标评标中予以扣分。4、投标人需承诺：协助招标人、总承包商、施工单位、地方消防部门，做好智能库项目消防器材供货所涉及区域的消防检查、验收、整改、相关手续办理等工作（注：含提交、整理验收资料），并满足消防验收规范、标准及要求，能顺利通过当地消防验收，并且相关费用已含在投标报价中。5、投标人需提供覆盖投标产品的3C证书（自愿性认证）及国家检测中心出具的型式试验检测报告。上述证书及报告复印件需加盖厂家公章。6、 投标人必须根据请购技术文件要求在投标文件中提供整套工程设计施工图纸、供货清单、及喷水灭火系统的计算书（否决项）。7、评标办法中：供货业绩原为“同类产品供货业绩，近五年（2016年10月至今），提供业绩合同和技术协议的复印件”修改为：“同类产品供货业绩，近五年（2017年1月至今），提供业绩合同和技术协议的复印件” 。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;19．投标说明：（1）评标委员会将按照要求对投标文件中的证书、资质和发票的真实性进行核验，请投标人严格按照招标文件要求提供。 （2）请购买招标文件的投标人及时下载招标文件，并仔细阅读招标文件附件“其它”中的《CA全流程电子标特别说明及三个操作手册》。 （3）本标为全流程电子标，加密版投标文件在投标截止时间前完成系统上传，无需提供纸质版投标文件，其他关于投标文件递交形式的要求以招标文件附件《CA全流程电子标特别说明及三个操作手册》为准。 （4）本标为电子CA标，首次参加的投标人，请尽快向网站购买U-KEY，并下载标书制作软件用于打开招标文件和编制投标文件。操作流程见网站说明。 （5）购买标书请点击本招标公告网页最下方“我要投标”直接支付标书费，不接受其他方式支付。标书一经售出，不予退还。招标项目中含“（重招）”二字的，为重新招标项目，第一次招标已购买的投标人可免于支付重新招标的标书费（特殊情况除外，以系统状态为准），但须在招标文件售卖期内进入系统完成报名方可直接下载标书。重新招标项目的保证金仍需按照招标文件要求的流程和金额正常支付。 （6）购买标书后如放弃投标，须购买标书后3日内发加盖公章的《放弃投标声明》以及购买招标文件的证明截图至招标联系人邮箱，请以中国石化EC平台登记的邮箱发送。未按规定提交《放弃投标声明》且不参与投标，导致影响中石化采购进度的，计入供应商诚信评价。 （7）费用支付问题请询400-819-8786或95388-5；购买U-KEY、招标文件下载以及系统网站网页等问题，请询400-819-8786。 （8）招标人对招标公告和招标文件的修改和澄清（包括但不限于对招标公告的修改、对招标文件的修改和澄清、开标时间调整的等）均以澄清的方式在招标平台系统中发布，投标人应及时关注和查阅招标平台中的澄清内容，对澄清内容有疑问的及时联系招标公告中的招标代理机构联系人，因投标人未及时查看招标文件澄清导致的损失和责任由投标人自行承担。 （9）对于招标文件澄清或修改，投标人如认为影响投标文件编制的，应在接到澄清后按照澄清规定的时间向招标机构提出，以便及时处理。不提出的，视为同意投标截止时间。 （10）保证金递交说明： （A）为缓解投标人的资金压力，投标保证金可通过够买投标险来降低资金成本。投标保证金保险，是保险公司对投标人投标行为的一种保证担保方式。投标企业可使用投标保证金保险的方式缴纳投标保证金，二者具备同等法律效力。登录电招平台，选择缴纳投标保证金模块，点击并选择“易保险电子保单”，按照流程操作，收到缴费通知，即通过核保。在投标文件制作时，同投标文件上传至电招平台即可。 (B)若通过保函形式缴纳保证金，投标人务必提前邮件和招标联系人沟通确认，并严格执行招标文件中对保函的要求。保函受益人应为：中国石化国际事业有限公司南京招标中心。保函原件必须在投标截止时间前当面递交。 (C) 在商务唱标环节，投标人以电汇和在线支付方式缴纳投标保证金的，系统显示投标保证金实际支付金额；投标人以投标保函和保证金保险方式支付投标保证金的，以招标中心开标人员现场宣布为准。 （11）投标人须仔细阅读招标要求，进行明确响应并提供实质性证明材料，招标文件中的各项模板供投标人参考，请投标人对自己的投标文件响应内容负责。 （12）请在投标文件中提供《阳光供应链采购承诺书》（模板详见附件-《阳光供应链采购承诺书》）。 （13）根据《中国石化物资采购招标投标诚信管理办法》，招标机构对以下行为计入“投标信用评价”，并在后续招标评标中予以体现。 （A）未按规定时间推动阳光供应链承诺书实施招标的。 （B）未按规定时间之前缴纳中标服务费欠款的。 （C）未按招标文件规定时间提交《放弃投标声明》且不参与投标，导致影响中石化采购进度的。 （D）不按规定提出异议或投诉，虚假、恶意投诉，阻碍招标投标活动正常进行的。</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;20．联系方式：</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;投标咨询：</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联 系 人： 徐旭</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;电 话： 025-86486171（若电话未通请发邮件）</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;电 子 邮 件： wzxux@sinopec.com</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;技术咨询：</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;联 系 人： 郭方</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;电 话： 13911330829</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;电 子 邮 件：</p>
          <p class="text-r">中国石化国际事业有限公司</p>
          <p class="text-r">2022年1月23日</p>
        </div>

      </div>
      <div class="right">
<!--        <div class="r-c">-->
<!--          <div class="fts-20 title">采购信息发布</div>-->
<!--          <p class="fts-18">企业和个人采购需求信息发布</p>-->
<!--          <p class="fts-18 mt-20">收费标准：600元/千条</p>-->
<!--          <p class="fts-18">收费方式：对公转账</p>-->
<!--          <p class="fts-18 mt-20">发布信息请致电01088589100</p>-->
<!--          <p class="fts-18">联系人：范老师</p>-->
<!--          <p class="fts-18 mt-20">请您通过网银转账，或自行到银行进行汇款，汇款账号如下：</p>-->
<!--          <p class="fts-18">户 名：北京正采信息技术研究院有限公司</p>-->
<!--          <p class="fts-18">账 号：0200207709200084916</p>-->
<!--          <p class="fts-18">开户行：中国工商银行股份有限公司北京西四环支行</p>-->
<!--          <p class="fts-18">行 号：102100020778 (非必填)</p>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
// import router from "../../router";

export default {
  name: "info1",
  created() {
    let temp = localStorage.getItem("wzId1")
    if (temp != 1) {
      this.$router.replace("/")
    }
  },
  unmounted() {
    localStorage.removeItem("wzId1")
  }
};
</script>

<style lang="scss" scoped>
.w-1 {
  width: 100px;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  font-size: 18px;
}
.w-2 {
  width: 300px;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
  font-size: 18px;
}
.text-r {
  text-align: right;
}
.info {
  background-color: #f1f1f1;
  padding-bottom: 90px;
  min-width: 1200px;
  .info-content {
    width: 1200px;
    margin: auto;
    display: flex;
    padding-top: 40px;
    .left {
      width: 840px;
      .left-c {
        padding: 20px;
        p {
          font-size: 18px;
          line-height: 35px;
        }
      }
      //.title {
      //  font-size: 20px;
      //  font-weight: bold;
      //  border-bottom: 1px solid #bbbbbb;
      //  padding: 20px 20px;
      //}
      .l-t {
        border-bottom: 1px solid #bbbbbb;
        padding: 20px 20px;
      }
      .title {
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        padding: 0 15px;
      }
      .time {
        font-size: 16px;
        text-align: center;
        margin-top: 8px;
      }
      .text1 {
        color: red;
        padding: 20px 0;
        font-size: 16px;
      }
    }
    .right {
      width: 360px;
      padding: 20px 0 0 15px;
      position: relative;
      .r-c {
        width: 320px;
        background-color: #089CB0;
        //height: 430px;
        padding: 30px 10px;
        border-radius: 8px;
        box-sizing: border-box;
        color: #ffffff;

        position: fixed;
        p {
          margin: 2px 0;
        }
        .title {
          //font-weight: 800;
        }
        .mt-20 {
          margin-top: 15px;
        }
        .fts-20 {
          font-size: 20px;
        }
        .fts-18 {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
